module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Light.885e5558.ttf";